// extracted by mini-css-extract-plugin
export default {"SplashScreen":"SplashScreen_SplashScreen__4BjEo","SplashScreenImgContainer":"SplashScreen_SplashScreenImgContainer__wtX5C"};